<template>
  <modal ref='modal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('records_list.copy_to_folder', {number: records.length})}}</h5>
    </template>

    <template #body>
      <form @submit.prevent='copyFile($event)' class="modal-fix">
        <div class='modal-body'>
          <label>{{ $t('record_show.folder') }}</label>

          <div>
            <single-select :template='folderTemplate' :options='folders' name='record[folder_id]' v-model='folder' />
          </div>
        </div>

        <div class='modal-footer'>
          <input type='submit' :value="$t('records_list.copy_files')" class='btn btn-primary float-right' />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'
  import _single_select from '../_single_select'

  export default {
    components: {
      modal: _modal,
      'single-select': _single_select,
    },
    data() {
      return {
        records: [],
        folder: {},
      }
    },
    computed: {
      folders() {
        return this.lists.folders || []
      },
    },
    methods: {
      open(records) {
        this.records = records
        this.listStore.getFolders().then(() => {
          this.$refs.modal.open()
        })
      },
      copyFile(e) {
        this.store.bulkCopyRecords(this.records, this.folder.id).then(() => {
          this.store.sendMetrics({name: 'bulk_copy_file_from_shared_folder', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.$refs.modal.close()
        })
      }
    }
  }
</script>
